/**
 * Tenants pick their own tint colours, so no fixed label colour is safe on top
 * of one: white works on a dark tint and vanishes on a light one. Choose the
 * label from the tint's measured luminance instead.
 *
 * With no tint we fall back to the themed --primary pair, which is light in the
 * dark theme and dark in the others.
 */
export function tintLabel(tint?: string | null): React.CSSProperties {
  if (!tint) return { backgroundColor: "var(--primary)", color: "var(--primary-foreground)" };
  const m = /^#?([0-9a-fA-F]{6})$/.exec(tint.trim());
  if (!m) return { backgroundColor: tint, color: "#ffffff" };
  const n = parseInt(m[1], 16);
  const lum = [(n >> 16) & 255, (n >> 8) & 255, n & 255]
    .map((v) => {
      const x = v / 255;
      return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    })
    .reduce((acc, c, i) => acc + [0.2126, 0.7152, 0.0722][i] * c, 0);
  const onWhite = 1.05 / (lum + 0.05);
  const onBlack = (lum + 0.05) / 0.05;
  return { backgroundColor: tint, color: onWhite >= onBlack ? "#ffffff" : "#111111" };
}
